import React, { useState, useEffect, useContext } from "react";
import * as ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  useParams,
  useNavigate,
  Navigate,
} from "react-router-dom";

import "./devlink/global.css";
import { DevLinkProvider } from "./devlink";

import AuthError from "./components/onboarding/AuthError";

import "./styles/tailwind.css";

import Error from "./components/Error";
import ConsentBanner from "./components/ConsentBanner";
import Home from "./components/Home";
import UserProvider, { useUserContext } from "./components/UserProvider";
import { CategoryProvider } from "./components/Home/CategoryPublisherList";
import GoogleAuthProvider from "./components/GoogleAuthProvider";
import Upgrade from "./components/Home/Upgrade";
import Publisher from "./components/Home/Publisher";
import Newsletter from "./components/Home/Newsletter";
import Settings from "./components/Home/Settings";
import { ThemeProvider } from "./components/Home/navbar/ThemeToggle"
import Topics from "./components/Topics";
import {
  Onboarding,
  SignInWithGoogle,
  Intro,
  SelectCategories,
  Success,
} from "./components/onboarding";
import GeneratingSummaryWrapper from "./components/onboarding/GeneratingSummary";

import { sendRequest } from "./api";
import { GoogleOAuthProvider } from "@react-oauth/google";

import "./app.css";

export const LINKS = {
  settings: "/settings",
  topics: "/topics",
};

const DataProvider = ({ dataFn, componentFn }) => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const params = useParams();

  async function fetchData() {
    try {
      const response = await dataFn(params);
      setData(response);
    } catch (error) {
      setError(error.message);
    }
  }

  // useEffect(() => {
  //   if (dataFn) {
  //     fetchData();
  //   }
  // }, [dataFn]);

  const Component = ({ data, error }) => {
    const navigate = useNavigate();

    return (
      <GoogleOAuthProvider clientId={process.env.GOOGLE_CLIENT_ID}>
        <DevLinkProvider>
          <CategoryProvider>
            <UserProvider>
              <GoogleAuthProvider>
                <ThemeProvider>
                  <>
                    {error && <Error message={error} />}
                    {componentFn(data, async () => dataFn && fetchData())}
                  </>
                </ThemeProvider>
              </GoogleAuthProvider>
            </UserProvider>
          </CategoryProvider>
        </DevLinkProvider>
      </GoogleOAuthProvider>
    );
  };

  if (!dataFn) {
    return <Component error={error} />;
  }

  return <Component data={data} error={error} />;
};

const SettingsWrapper = () => {
  const { userData } = useUserContext();
  return <Settings userData={userData} />;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <DataProvider componentFn={() => <Home />} />,
    children: [
      {
        path: "/publisher/:publisherName",
        element: <DataProvider componentFn={() => <Home />} />,
      },
      {
        path: "/newsletter/:newsletterId",
        element: <DataProvider componentFn={() => <Home />} />,
      },
    ],
  },
  {
    path: "/settings",
    element: <Settings />,
  },
  {
    path: "/topics",
    element: <DataProvider componentFn={() => <Topics />} />,
  },
  {
    path: "/onboarding",
    element: <DataProvider componentFn={() => <Onboarding />} />,
    children: [
      {
        index: true,
        element: <SignInWithGoogle />,
      },
      {
        path: "intro",
        element: <Intro />,
      },
      {
        path: "select-categories",
        element: <SelectCategories />,
      },
      {
        path: "generating-summary",
        element: <GeneratingSummaryWrapper />,
      },
      {
        path: "success",
        element: <Success />,
      },
    ],
  },
  {
    path: "/auth-error",
    element: <AuthError />,
  },
  {
    path: "/upgrade",
    element: <Upgrade />,
  },
  // {
  //   path: "/email-preview",
  //   element: <DataProvider
  //     dataFn={() => sendRequest('/users')}
  //     componentFn={([user]) => <EmailSummary user_summary={user && user.user_summaries[0]} />}
  //   />,
  // }
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  // <React.StrictMode> why is this a thing
  <>
    <RouterProvider router={router} />
    {/* <ConsentBanner /> */}
  </>,
  // </React.StrictMode>
);
